<template>
  <div class="sticky bottom-0 right-0 z-40 cursor-pointer" @click="routeToWebchat" v-if="!footerStore.isShowWebchat">
    <img src="@/assets/images/shared/iconWebchat.svg" class="ml-auto" />
  </div>
  <div class="sticky bottom-0 right-0 z-40" v-show="footerStore.isShowWebchat">
    <div class="ml-auto cursor-pointer" style="width: 0.8vw; height: 0.8vw; width: 1.5vw; height: 1.5vw; border-radius: 50%; background: white; padding: 0.3vw; display: flex; align-items: center; top: 15px; right: 15px; position: absolute" @click="footerStore.isShowWebchat = false">
      <img src="@/assets/images/shared/eclipse.svg" style="width: inherit; height: inherit" />
    </div>
    <iframe id="myFrame" :src="WEBCHAT_URL" :style="'width:400px;height:604px;border-top-left-radius: 30px;border-top-right-radius: 30px;margin-left:auto'" ref="webchatIframe"></iframe>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useFooterStore } from "@/stores/footer";

const router = useRouter();
const footerStore = useFooterStore();

const WEBCHAT_URL = import.meta.env.WEBCHAT_URL;
const ENV = import.meta.env.MODE;

const routeToWebchat = () => {
  console.log("env", ENV, WEBCHAT_URL);
  footerStore.isShowWebchat = true;
  //window.open(WEBCHAT_URL, "_blank", "noreferrer");
  //window.open(WEBCHAT_URL, "_self");
};
</script>


